
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dining/articles",
      function () {
        return require("private-next-pages/dining/articles.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dining/articles"])
      });
    }
  